export const PRISMIC_REPO_NAME = 'ywlaw';
